import {Stack, SvgIcon, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';

import {ReactComponent as calendarIllustration} from 'assets/svg/calendar-illustration.svg';

const BookingPageExpired = () => {
  const {t} = useTranslation();
  const creatorDisplayName = useSelector((s) => s.bookAppointments.createrDisplayName);
  return (
    <Stack alignItems="center" justifyContent="center" height="100%">
      <SvgIcon
        style={{width: '12.5rem', height: '12.5rem'}}
        component={calendarIllustration}
        fontSize="inherit"
        inheritViewBox
      />
      <Typography
        sx={(theme) => ({
          fontWeight: 600,
          fontSize: '1rem',
          lineHeight: '1.25rem',
          color: theme.palette.text.strongerNeutral,
          marginTop: '1rem',
          textAlign: 'center',
        })}
      >{t('payment.bookingPageExpired')}</Typography>
      <Typography
        sx={(theme) => ({
          fontWeight: 400,
          fontSize: '0.875rem',
          lineHeight: '1.125rem',
          color: theme.palette.text.neutral,
          textAlign: 'center',
          width: '20rem',
        })}
      >
        {t('payment.bookingPageExpiredDesc', {hostName: creatorDisplayName})}
      </Typography>
    </Stack>
  );
};

export default BookingPageExpired;
